import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";


import { Navbar, Collapse } from "react-bootstrap";
import RedesSociales from "../RedesSociales";
import useProduct from "../../hooks/useProduct";


import brand from "../../assets/images/brand/Tensolite-Isologotipo-con-bajada.svg";
import brandV from "../../assets/images/brand/Tensolite-Isologotipo-vertical.svg";


import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import SearchIcon from "@mui/icons-material/Search";
import Offcanvas from "react-bootstrap/Offcanvas";
import ProductLiNav from "../products/ProductLiNav";
import BurguerButton from "./BurguerButton";
import useBuscador from "../../hooks/useBuscador";
import DropDowContact from "./DropdownContact";

const PrimaryNav = () => {
  const { products, setProducts } = useProduct();
  const {
    busqueda,
    setBusqueda,
    HandleSearch,
    suggestions,
    setSuggestions,
    resultadosBusqueda,
  } = useBuscador();

  useEffect(() => {
    setProducts(
      products?.sort(
        (a, b) =>
          a.position?.find((obj) => obj)?.product -
          b.position?.find((obj) => obj)?.product
      )
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [products]);


  const [openPL, setOpenPL] = useState(true);
  const [openPE, setOpenPE] = useState(true);
  const [openPA, setOpenPA] = useState(true);

  const [navBar, setNavBar] = useState(false);

  const [clicked, setClicked] = useState(false);

  const [show, setShow] = useState(false);
  const [timeoutId, setTimeoutId] = useState("");
  const [inputText, setInputText] = useState("");
  const [showSearch, setShowSearch] = useState(false);

  const logueado = JSON.parse(localStorage.getItem('Usuario'))

  const handleClick = () => {
    setClicked(!clicked);
    document
      ?.querySelector("#navs__drop-nav-products button")
      ?.classList.add("active");
  };

  const navScroll = () => {
    if (window.scrollY >= 20) {
      setNavBar(true);
      setClicked(false);
      document
        ?.querySelector("#navs__drop-nav-products button")
        ?.classList.remove("active");
    } else {
      setNavBar(false);
    }
  };
  window.addEventListener("scroll", navScroll);

  const handleInputSearchChange = async ({ target }) => {
    setSuggestions([]);
    setInputText(target.value);
    setBusqueda({
      ...busqueda,
      search: target.value,
    });
    if (target.value.length >= 4) {
      clearTimeout(timeoutId); 
      const newTimeoutId = setTimeout(() => {
        HandleSearch();
        setSuggestions(resultadosBusqueda?.allWords);
      }, 1000); 
      setTimeoutId(newTimeoutId); 
    } else {
      setSuggestions([]);
    }
  };
  useEffect(() => {
    setSuggestions([]);
  }, []);
  useEffect(() => {
    setSuggestions(resultadosBusqueda?.allWords || []);
  }, [resultadosBusqueda]);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const SearchClick = () => {
    setShowSearch(!showSearch);
    setSuggestions([]);
  };
  const navigate = useNavigate();

  const HandleClickSearch = () => {
    HandleSearch();
    setShowSearch(!showSearch);
  };

  const handleLogout = () => {
    localStorage.removeItem("Usuario");
  };

  return (
    <>
      <header
        id="navs__header"
        className={`${
          clicked ? "active" : "" || navBar ? "active-scroll" : ""
        }`}
      >
        <div role="presentation" className="bg-nav"></div>
        <section className="nav__topit container">
          <nav className="redireccion-pp" aria-labelledby="login_user">
            <p id="login_user">Panel Autogestión</p>
            <a
              href="https://panel.tensolite.com/login"
              target="_blank"
              rel="noreferrer"
            >
              Cliente
            </a>
            |
            <a
              href="https://proveedores.tensolite.com/"
              target="_blank"
              rel="noreferrer"
            >
              Proveedor
            </a>
            |
          </nav>
          {logueado && (
          <nav className="redireccion-pp" >
            <a href="/clientes/login" onClick={handleLogout}>
              Logout
            </a>
          </nav>
          )}
        </section>

        <div className="container d-flex">
          <Navbar.Brand className="desk" href="/">
            <img src={brand} alt="Logo de Tensolite" />
          </Navbar.Brand>
          <Navbar.Brand className="mobil" href="/">
            <img src={brandV} alt="Logo de Tensolite" className=" logo-mobil" />
          </Navbar.Brand>
          <nav>
            <ul className="container">
              <li>
                <button
                  variant="primary"
                  onClick={handleShow}
                  className="navs__av_item-1 cursor-point"
                >
                  Productos <ArrowForwardIcon />
                </button>
              </li>
              <li className="calculadora">
                <a href="/calculadora-losa-con-viguetas">
                  Calculadora <ArrowForwardIcon />
                </a>
              </li>
              <li>
                <a href="/somos-tensolite">
                  Empresa <ArrowForwardIcon />
                </a>
              </li>
              <li>
                <a href="/tensolite-en-el-mundo">
                  En el mundo <ArrowForwardIcon />
                </a>
              </li>
              <li className="navs__tensonews">
                <a href="/tensonews">
                  TensoNews <ArrowForwardIcon />
                </a>
              </li>
              <li>
                <DropDowContact/>
              </li>
              <li>
                <a href="/clientes">
                  Clientes <ArrowForwardIcon />
                </a>
              </li>
              {logueado && (
              <li>
                <a href="/clientes/login" onClick={handleLogout} className="logout-display">
                  Logout <ArrowForwardIcon />
                </a>
              </li>
              )}
              <li>
                <button id="search-button" onClick={SearchClick}>
                  <SearchIcon />
                </button>
              </li>
            </ul>

            <hr />
            <ul id="navs__link2" className="container">
              <li>
                <a href="/preguntas-frecuentes">
                  Preguntas Frecuentes
                  <ArrowForwardIcon />
                </a>
              </li>
              <li title="Panel Autogestión">
                <a
                  onClick={() => setOpenPA(!openPA)}
                  aria-controls="pa"
                  aria-expanded={!openPA}
                  type="button"
                  className="pa_button"
                >
                  PANEL AUTOGESTIÓN <ArrowForwardIcon />
                </a>
                <Collapse in={!openPA}>
                  <div id="pa">
                    <ul>
                      <a
                        className="li_pa"
                        href="https://panel.tensolite.com/login"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Cliente
                      </a>
                    </ul>
                    <ul>
                      <a
                        className="li_pa"
                        href="https://proveedores.tensolite.com/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Proveedor
                      </a>
                    </ul>
                  </div>
                </Collapse>
              </li>
            </ul>
          </nav>
          <RedesSociales />
          <ul
            aria-labelledby="navs__drop-nav-products"
            className={`navs__menudrop ${clicked ? "active" : ""}`}
          >
            <Offcanvas
              show={show}
              onHide={handleClose}
              id="header-nav-producto"
            >
              <Offcanvas.Header closeButton>
                <Navbar.Brand className="desk" href="/">
                  <img src={brand} alt="Logo de Tensolite" />
                </Navbar.Brand>
                <Navbar.Brand className="mobil" href="/">
                  <img
                    src={brandV}
                    alt="Logo de Tensolite"
                    className=" logo-mobil"
                  />
                </Navbar.Brand>
              </Offcanvas.Header>
              <Offcanvas.Body id="cuerpo-nav-producto">
                <li title="De línea" id="navs__drop-nav-product-linea">
                  <button
                    onClick={() => setOpenPL(!openPL)}
                    aria-controls="products-linea"
                    aria-expanded={openPL}
                    type="button"
                  >
                    De línea
                  </button>
                  <Collapse in={openPL}>
                    <div id="products-linea">
                      <ul>
                        {products?.map(
                          (product, index) =>
                            product?.type === "productoLinea" &&
                            product?.deleted !== true &&
                            product?.visible === true && (
                              <ProductLiNav key={index} product={product} />
                            )
                        )}
                      </ul>
                    </div>
                  </Collapse>
                </li>
                <li title="Especiales" id="navs__drop-nav-product-special">
                  <button
                    onClick={() => setOpenPE(!openPE)}
                    aria-controls="products-special"
                    aria-expanded={openPE}
                  >
                    Especiales
                  </button>
                  <Collapse in={openPE}>
                    <div id="products-special">
                      <ul>
                        {products.map(
                          (product, index) =>
                            product.type === "productoEspecial" &&
                            product?.deleted !== true &&
                            product?.visible === true && (
                              <ProductLiNav key={index} product={product} />
                            )
                        )}
                      </ul>
                    </div>
                  </Collapse>
                </li>
              </Offcanvas.Body>
            </Offcanvas>
          </ul>
          <div className="navs__burguer">
            <BurguerButton clicked={clicked} handleClick={handleClick} />
          </div>
          <ul
            aria-labelledby="navs__drop-nav-products"
            className={`navs__menudrop ${clicked ? "active" : ""}`}
          >
            <Offcanvas
              show={showSearch}
              onHide={SearchClick}
              id="header-nav-search"
            >
              <div className="container">
                <Offcanvas.Header closeButton>
                  <Navbar.Brand className="desk" href="/">
                    <img src={brand} alt="Logo de Tensolite" />
                  </Navbar.Brand>
                  <Navbar.Brand className="mobil" href="/">
                    <img
                      src={brandV}
                      alt="Logo de Tensolite"
                      className=" logo-mobil"
                    />
                  </Navbar.Brand>
                </Offcanvas.Header>
                <Offcanvas.Body id="cuerpo-nav-producto">
                  <div className="search-title--container">
                    <h1 className="search-title">¿Cómo te podemos ayudar?</h1>
                  </div>
                  <div className="search-input--container form-floating">
                    <input
                      type="text"
                      className="form-control input-focus"
                      name="title"
                      id="title"
                      placeholder="Busqueda"
                      onChange={handleInputSearchChange}
                      maxLength={30}
                      minLength={2}
                      required
                      onKeyDown={(event) => {
                        if (event.key === "Enter") {
                          HandleClickSearch();
                          navigate("/resultado-busqueda");
                        }
                      }}
                    />
                    <label htmlFor="title">Búsqueda </label>
                    <Link
                      to={`${
                        inputText.length > 0 ? "/resultado-busqueda" : ""
                      }`}
                    >
                      <div
                        onClick={HandleClickSearch}
                        className={`search-svg--container ${
                          inputText.length > 0 ? "" : "disabled"
                        }`}
                      >
                        <SearchIcon />
                      </div>
                    </Link>
                  </div>
                  <ul>
                    {suggestions?.map((suggestion) => (
                      <li
                        to="/resultado-busqueda"
                        key={suggestion}
                        onClick={() => {
                          setTimeout(() => {
                            setBusqueda({
                              ...busqueda,
                              search: suggestion,
                            });
                            setSuggestions([]);
                            HandleClickSearch();
                            navigate("/resultado-busqueda");
                          }, 0);
                        }}
                      >
                        {suggestion}
                      </li>
                    ))}
                  </ul>
                </Offcanvas.Body>
              </div>
            </Offcanvas>
          </ul>
        </div>
      </header>
    </>
  );
};

export default PrimaryNav;
